<template>
    <i v-if="module.mdiIcon" class="mdi module-mdi" v-bind:class="`mdi-${module.mdiIcon}`"></i>
    <div v-else-if="module.icondata" v-html="legacy"></div>
    <i v-else class="mdi module-mdi text-muted mdi-help-circle-outline"></i>
</template>

<script>
export default
{
    name: 'ModuleIcon',
    props:
    {
        module:
        {
            type: Object,
            required: true,
        },
    },
    computed:
    {
        /**
         * Modules that predate the icon picker still come with an svg from
         * static/icons, which the android app also reads. A module only moves to
         * Material Design Icons once someone picks one for it.
         *
         * The svg used to be recoloured with the module's own iconColor, which
         * is how these came out black here while the app drew them in the brand
         * colour. iconColor is not offered any more, so both paths use the brand
         * colour and a device icon looks the same on either screen.
         */
        legacy()
        {
            const me = this;

            return me.module.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="#3493ca"');
        },
    },
};
</script>
